module.exports = __webpack_public_path__ + "img/bleu_roi_1349.b23207e0.jpg";